import React, { useContext, useEffect } from 'react';
// design
import { Form, Input, Select, Button, message } from 'antd';
// method
import { getMethod, putMethod } from '../services/methods';
// context
import { GlobalContext } from "../context/globalContext";
const { Option } = Select;

export default function Profile() {
    // context
    const { contextData, dispatch } = useContext(GlobalContext);
    const [form] = Form.useForm();
    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 2 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 8 },
        },
    };

    async function fetchData() {
        const userData = await getMethod(`/user/single/${contextData.userData._id}`);
        form.setFieldsValue(userData)
    }

    useEffect(() => {
        fetchData();
    }, [])

    const formSubmit = async () => {
        const update = await putMethod(`/user/${contextData.userData._id}`, form.getFieldsValue());
        if(update.status==200){
            message.success("İşlem başarılı.")
        }
    };

    return (
        <Form
            {...formItemLayout}
            form={form}
            layout="horizontal"
            name="form_in_modal"
            initialValues={{
                modifier: 'public'
            }}
            onFinish={() => formSubmit()}
        >
            <Form.Item
                name="name"
                label="Ad"
                rules={[
                    {
                        required: true,
                        message: 'Lütfen bu alanı doldurunuz!',
                    },
                ]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                name="surname"
                label="Soyad"
                rules={[
                    {
                        required: true,
                        message: 'Lütfen bu alanı doldurunuz!',
                    },
                ]}
            >
                <Input />
            </Form.Item>

            {/*<Form.Item*/}
            {/*    name="email"*/}
            {/*    label="Email"*/}
            {/*    rules={[*/}
            {/*        {*/}
            {/*            required: true,*/}
            {/*            message: 'Lütfen bu alanı doldurunuz!',*/}
            {/*        },*/}
            {/*    ]}*/}
            {/*>*/}
            {/*    <Input />*/}
            {/*</Form.Item>*/}

            <Form.Item
                name="phone"
                label="Tel"
                rules={[
                    {
                        required: true,
                        message: 'Lütfen bu alanı doldurunuz!',
                    },
                ]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                name="role"
                label="Rol"
                rules={[
                    {
                        required: true,
                        message: 'Lütfen bu alanı doldurunuz!',
                    },
                ]}
            >
                <Select allowClear>
                    {
                        ["admin"].includes(contextData.userData.role) &&
                        <>
                            <Option value="admin">Admin</Option>
                            <Option value="admin-center">Admin Center</Option>
                        </>
                    }
                    {
                        ["admin", "admin-center", "admin-state"].includes(contextData.userData.role) &&
                        <>
                            <Option value="admin-state">İl admin</Option>
                        </>
                    }
                    {
                        (["admin", "admin-center", "admin-state", "admin-county"].includes(contextData.userData.role)) &&
                        <Option value="admin-county">İlçe admin</Option>
                    }
                    <Option value="delegate">Teşkilat Mensubu</Option>
                </Select>
            </Form.Item>

            <Form.Item
                name="state"
                label="İl"
                normalize={value => (value || '').toLocaleUpperCase('tr-TR')}
                rules={[
                    {
                        required: true,
                        message: 'Lütfen bu alanı doldurunuz!',
                    },
                ]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                name="county"
                label="İlçe"
                normalize={value => (value || '').toLocaleUpperCase('tr-TR')}
                rules={[
                    {
                        required: true,
                        message: 'Lütfen bu alanı doldurunuz!',
                    },
                ]}
            >
                <Input />
            </Form.Item>

            <Form.Item>
                <Button shape="round" type="primary" htmlType="submit">
                    Kaydet
                </Button>
            </Form.Item>

        </Form>

    )
}
